import { render, staticRenderFns } from "./ContacteleMeleColorMetal.vue?vue&type=template&id=671a21de&"
import script from "./ContacteleMeleColorMetal.vue?vue&type=script&lang=ts&"
export * from "./ContacteleMeleColorMetal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});qInstall(component, 'directives', {Ripple});
